import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { t } from "i18next";
import amitimLogo from "../../assets/images/Amitim_Logo_Tagline_RGB.png";
import { dateSlashFormat } from "../../utils/helpers/dateFormatter";

export const exportExcelData = (
  headers,
  data,
  userId,
  validityDate,
  exportMainTable,
  sepTableName,
  mainTableName,
  excelfooter1,
  excelfooter2,
  excelfooter3,
  idNumber,
  createDate,
  currentDate,
  employersReportInNIS,
  divisionIntoProvision
 
) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Amitim-LTD";
  workbook.created = new Date();
  workbook.properties.date1904 = true;
  workbook.calcProperties.fullCalcOnLoad = true;

  const sheet = workbook.addWorksheet(
    `${exportMainTable ? mainTableName : sepTableName}`,
    {
      views: [{ showGridLines: false, rightToLeft: true }],
      pageSetup: { fitToPage: true, orientation: "landscape" },
    }
  );

  initExcelDoc(workbook, sheet, userId, validityDate, exportMainTable,mainTableName,sepTableName,idNumber,createDate,currentDate);

  sheet.addTable({
    name: "DepositsTable",
    ref: "A12",
    columns: headers,
    rows: data,
  });

  exportMainTable && createTableExtraHeader(sheet,employersReportInNIS,divisionIntoProvision);

  handleTableDesign(sheet, exportMainTable);

  handleTableCellsWidth(sheet, exportMainTable);

  createDocLastSection(sheet,excelfooter1,excelfooter2,excelfooter3);

//   workbook.xlsx.writeBuffer(/*{ useStyles: true }*/).then(function (buffer) {
//   //  TODO: file name like in maasikim
//     saveAs(
//       new Blob([buffer], {
//         type: "application/octet-stream",
//       }),
//       `${userId}-${dateSlashFormat(
//         new Date().toISOString()
//       )}-${new Date().toLocaleTimeString()}.xlsx`
//     );
//   });
// };
workbook.xlsx.writeBuffer(/*{ useStyles: true }*/).then(function (buffer) {
  //  TODO: file name like in maasikim
    saveAs(
      new Blob([buffer], {
        type: "application/octet-stream",
      }),
      `${userId}-${dateSlashFormat(
        new Date().toISOString()
      )}-${new Date().toLocaleTimeString()}.xlsx`
    );
  });
};

const initExcelDoc = (
  workbook,
  sheet,
  userId,
  validityDate,
  exportMainTable,
  mainTableName,  
  sepTableName,
  idNumber,
  createDate,
  currentDate 
) => {
  const imageId1 = workbook.addImage({
    base64: amitimLogo,
    extension: "png",
  });

  sheet.addImage(imageId1, "A2:B4");

  sheet.getCell("E2").value = {
    richText: [
      {
        font: {
          size: 16,
          name: "Arial",
          underline: true,
          bold: true,
        },
        text: `${exportMainTable ? mainTableName : sepTableName}`,
      },
    ],
  };

  sheet.getCell("A7").value = {
    richText: [
      {
        font: {
          size: 11,
          name: "Arial",
          bold: true,
        },
        text: idNumber +  `: ${userId}`,
      },
    ],
  };

  sheet.getCell("A8").value = {
    richText: [
      {
        font: {
          size: 11,
          name: "Arial",
          bold: true,
        },
        text: createDate + `: ${dateSlashFormat(new Date().toISOString())}`,
      },
    ],
  };

  sheet.getCell("A9").value = {
    richText: [
      {
        font: {
          size: 11,
          name: "Arial",
          bold: true,
        },
        text: currentDate + ` : ${dateSlashFormat(validityDate)}`,
      },
    ],
  };
};

const createTableExtraHeader = (sheet,employersReportInNIS,divisionIntoProvision) => {
  sheet.mergeCells("H11:L11");
  sheet.getCell("H11").value = {
    richText: [
      {
        font: {
          size: 11,
          name: "Arial",
          bold: true,
        },
        text: employersReportInNIS,
      },
    ],
  };

  sheet.mergeCells("M11:Q11");
  sheet.getCell("M11").value = {
    richText: [
      {
        font: {
          size: 11,
          name: "Arial",
          bold: true,
        },
        text: divisionIntoProvision,
      },
    ],
  };

  const extraHeaderRow = sheet.getRow(11);
  extraHeaderRow.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };
  extraHeaderRow.height = 25;

  extraHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF3AC0F2" },
    };
  });

  //The end of the header
  const lastHeaderCell = sheet.getCell("Q11");
  lastHeaderCell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  lastHeaderCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF3AC0F2" },
  };
};

const handleTableDesign = (sheet, exportMainTable) => {
  let rowIndex = 12;
  for (rowIndex; rowIndex <= sheet.rowCount; rowIndex++) {
    const row = sheet.getRow(rowIndex);
    row.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      if (
        exportMainTable &&
        (cell._address[0] === "K" || cell._address[0] === "P")
      ) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD3D3D3" },
        };
      }
    });

    if (rowIndex === 12) {
      row.eachCell((cell) => {
        if (
          exportMainTable &&
          (cell._address[0] === "K" || cell._address[0] === "P")
        ) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD3D3D3" },
          };
        } else {
          cell.fill = {
            type: "pattern",
            pattern: "none",
            bgColor: { argb: "#ffffff" },
          };
        }
        cell.font = {
          bold: true,
          color: "#2d3032",
        };
      });
    }
  }
};

const handleTableCellsWidth = (sheet, exportMainTable) => {
  sheet.columns.forEach(function (column, i) {
    // if (i !== 0) {
    var maxLength = 0;
    column["eachCell"]({ includeEmpty: true }, function (cell) {
      var columnLength = cell.value ? cell.value.toString().length : 10;
      if (columnLength > maxLength) {
        maxLength = columnLength;
      }
    });
    column.width = maxLength < 10 ? 10 : maxLength;
    // }
  });

  if (exportMainTable) {
    for (let i = 7; i <= 17; i++) {
      const col = sheet.getColumn(i);
      if (i === 8 || i === 17) {
        col.width = 8;
      } else {
        col.width = 12;
      }
    }

    const lastCol = sheet.getColumn(18);
    lastCol.width = 15;
  }
};

const createDocLastSection = (sheet,excelfooter1,excelfooter2,excelfooter3) => {
  let tableLastRowIndex = +sheet
    .getTable("DepositsTable")
    .table.tableRef.split(":")[1]
    .substring(1);

  sheet.getCell(`A${tableLastRowIndex + 5}`).value = {
    richText: [
      {
        font: {
          size: 12,
          name: "David",
        },
        text: excelfooter1,
      },
    ],
  };

  sheet.getCell(`A${tableLastRowIndex + 6}`).value = {
    richText: [
      {
        font: {
          size: 12,
          name: "David",
        },
        text: excelfooter2,
      },
    ],
  };

  sheet.getCell(`A${tableLastRowIndex + 7}`).value = {
    richText: [
      {
        font: {
          size: 12,
          name: "David",
        },
        text: excelfooter3,
      },
    ],
  };
};
